import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'tag',
  standalone: true,
  imports: [NgIf, RouterModule],
  styles: [],
  template: `<span *ngIf="!!value" [class]="'badge ' + classList"
    >{{ label ? label + ' ' : null }}
    @if(i){
    <i>{{ value }}</i>
    }@else {
    {{ value }}
    }
  </span>`,
})
export class TagComponent {
  @Input() label: any;
  @Input() value: any;
  @Input() i: boolean = true;
  @Input() classList: string = 'bg-success';
}
